export const organizationTypes = [
  {
    id: 1,
    name: 'Hospital',
    description: null,
    createdAt: '2019-09-09T20:47:41.364Z',
    updatedAt: '2019-09-09T20:47:41.364Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 2,
    name: 'Medical System',
    description: null,
    createdAt: '2019-09-09T20:47:41.364Z',
    updatedAt: '2019-09-09T20:47:41.364Z',
    createdBy: null,
    updatedBy: null,
  },
  {
    id: 3,
    name: 'Insurance Provider',
    description: null,
    createdAt: '2019-09-09T20:47:41.364Z',
    updatedAt: '2019-09-09T20:47:41.364Z',
    createdBy: null,
    updatedBy: null,
  },
];
